<template>
    <div>
        <div
            ref="scrollContainer"
            style="max-height: 150px; overflow-y: auto;"
            class="table-responsive"
        >
            <table id="my-table" class="table sticky-header">
                <thead>
                    <tr @click="triggerCheckBox('head')">
                        <th>
                            <b-form-checkbox
                                v-model="selectAllBln"
                                @change="toggleAll"
                                plain
                                label-style
                            ></b-form-checkbox>
                        </th>
                        <th>Select / Unselect All</th>
                    </tr>
                </thead>
                <tbody v-if="patients.length == 0">
                    <tr>
                        <td colspan="10">
                            <i>No records available</i>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr
                        v-for="patient in patients"
                        :key="patient.id"
                        @click="triggerCheckBox('body', patient)"
                    >
                        <td>
                            <b-form-checkbox
                                v-model="patient.selected"
                                @change="checkToggleAll"
                                plain
                            >
                            </b-form-checkbox>
                        </td>
                        <td>
                            {{ patient.name }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <span class="text-muted float-right">
            (
            {{ selectLength }}
            {{
                selectLength == 0 || selectLength == 1 ? "patient" : "patients"
            }}
            selected )
        </span>
    </div>
</template>
<script>
import { every, forEach, filter } from "lodash";
export default {
    inject: ["$validator"],
    props: {
        oriPatients: {
            type: Array
        }
    },
    data() {
        return {
            selectAllBln: false
        };
    },
    computed: {
        patients() {
            return this.oriPatients || [];
        },
        rows() {
            return this.patients.length;
        },
        selectLength() {
            return filter(this.patients, { selected: true }).length;
        }
    },
    watch: {
        selectLength(val) {
            this.$emit("patient-selected", val);
        }
    },
    methods: {
        toggleAll(checked) {
            forEach(this.patients, function (patient) {
                patient.selected = checked;
            });
        },
        checkToggleAll() {
            this.$nextTick(() => {
                this.selectAllBln = every(this.patients, { selected: true });
            });
        },
        triggerCheckBox(type, param) {
            if (type == "head") {
                this.selectAllBln = !this.selectAllBln;
                this.toggleAll(this.selectAllBln);
            } else {
                param.selected = !param.selected;
                this.checkToggleAll();
            }
        }
    }
};
</script>

<style scoped>
.sticky-header thead th {
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 10;
}

.table {
    border-collapse: separate;
}
.table thead th {
    border: 0;
}
.table td,
.table th {
    border-top: 1px solid #dee2e6;
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
}
</style>
